exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#shop-summary input[type=\"radio\"]:checked + label:before,\n#shop-summary input[type=\"radio\"]:not(:checked) + label:before {\n  content: none;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 20px;\n  height: 20px;\n  border: 2px solid #fff;\n  border-radius: 100%;\n}\n#shop-summary input[type=\"radio\"]:checked + label:after,\n#shop-summary input[type=\"radio\"]:not(:checked) + label:after {\n  content: none;\n  width: 12px;\n  height: 12px;\n  background: #fff;\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  border-radius: 100%;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n", ""]);

// exports
